export default __webpack_public_path__ + "129970d20805c489d192f1996979b461.ttf";